{
  "metadata": {
    "id": "one-dark-dark",
    "name": "One Dark",
    "description": "Портировано из темы «One Dark» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "one-dark.json",
      "project": "Th3Whit3Wolf",
      "url": "https://github.com/Th3Whit3Wolf/one-nvim",
      "upstreamFile": "packages/ui/src/theme/themes/one-dark.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 26.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.463,
      "paletteMaxS": 0.533,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.0,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 26.6,
      "syntaxVsTextMinDeltaE": 3.8,
      "chartsMinDeltaE": 26.9,
      "textSeparationDeltaE": 10.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "number",
          "b": "type",
          "deltaE": 16.1
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#61afef",
      "hover": "#74b9f1",
      "active": "#81bff2",
      "foreground": "#000000",
      "muted": "#61afef80",
      "emphasis": "#61afef"
    },
    "surface": {
      "background": "#282c34",
      "foreground": "#ccd1d8",
      "muted": "#393e46",
      "mutedForeground": "#b0b5be",
      "elevated": "#424750",
      "elevatedForeground": "#aeb5c1",
      "raised": "#575d67",
      "raisedForeground": "#d4d7de",
      "overlay": "#282c34cc",
      "subtle": "#30353d"
    },
    "interactive": {
      "border": "#5c616b",
      "borderHover": "#4d525b",
      "borderFocus": "#61afef",
      "selection": "#abb2bf29",
      "selectionForeground": "#abb2bf",
      "focus": "#61afef59",
      "focusRing": "#61afef61",
      "cursor": "#abb2bf",
      "hover": "#abb2bf1c",
      "active": "#abb2bf29"
    },
    "status": {
      "error": "#e17079",
      "errorForeground": "#000000",
      "errorBackground": "#e1707924",
      "errorBorder": "#e1707973",
      "warning": "#e5c07b",
      "warningForeground": "#000000",
      "warningBackground": "#e5c07b24",
      "warningBorder": "#e5c07b73",
      "success": "#98c379",
      "successForeground": "#000000",
      "successBackground": "#98c37924",
      "successBorder": "#98c37973",
      "info": "#d19a66",
      "infoForeground": "#000000",
      "infoBackground": "#d19a6624",
      "infoBorder": "#d19a6673"
    },
    "pr": {
      "open": "#98c379",
      "draft": "#c1c5cd",
      "blocked": "#e5c07b",
      "merged": "#56b6c2",
      "closed": "#e17079"
    },
    "syntax": {
      "base": {
        "background": "#4c515b",
        "foreground": "#abb2bf",
        "comment": "#bfc3ca",
        "keyword": "#e0b5ec",
        "string": "#abce92",
        "number": "#e2be9d",
        "function": "#8eced6",
        "variable": "#efb4b8",
        "type": "#e5c07b",
        "operator": "#8eced6"
      },
      "tokens": {
        "commentDoc": "#bfc3ca",
        "stringEscape": "#8eced6",
        "keywordImport": "#e0b5ec",
        "storageModifier": "#e0b5ec",
        "functionCall": "#8eced6",
        "method": "#8eced6",
        "variableProperty": "#8eced6",
        "variableOther": "#efb4b8",
        "variableGlobal": "#e2be9d",
        "variableLocal": "#8eced6",
        "parameter": "#efb4b8",
        "constant": "#e2be9d",
        "class": "#e5c07b",
        "className": "#e5c07b",
        "interface": "#e5c07b",
        "struct": "#e5c07b",
        "enum": "#e5c07b",
        "typeParameter": "#e5c07b",
        "namespace": "#e5c07b",
        "module": "#e0b5ec",
        "tag": "#e0b5ec",
        "jsxTag": "#e0b5ec",
        "tagAttribute": "#8eced6",
        "tagAttributeValue": "#abce92",
        "boolean": "#e2be9d",
        "decorator": "#e0b5ec",
        "label": "#8eced6",
        "regexp": "#abce92"
      }
    },
    "charts": {
      "series": [
        "#61afef",
        "#d19a66",
        "#98c379",
        "#e5e37b",
        "#e17079"
      ]
    },
    "chat": {
      "background": "#282c34",
      "userMessage": "#dfe2e7",
      "userMessageBackground": "#424750",
      "assistantMessage": "#bfc5ce",
      "assistantMessageBackground": "#393e46",
      "timestamp": "#c1c5cd",
      "divider": "#5c616b",
      "typing": "#c1c5cd"
    },
    "loading": {
      "spinner": "#61afef",
      "spinnerTrack": "#393e46",
      "skeleton": "#393e46",
      "shimmer": "#525761"
    },
    "tools": {
      "background": "#393e46",
      "border": "#5c616b",
      "headerHover": "#515660",
      "icon": "#61afef",
      "title": "#abb2bf",
      "description": "#c1c5cd",
      "edit": {
        "added": "#98c379",
        "addedBackground": "#98c37924",
        "removed": "#e17079",
        "removedBackground": "#e1707924",
        "modified": "#d19a66",
        "modifiedBackground": "#d19a6624",
        "lineNumber": "#c1c5cd"
      }
    },
    "markdown": {
      "heading1": "#abb2bf",
      "heading2": "#abb2bf",
      "heading3": "#abb2bf",
      "heading4": "#abb2bf",
      "link": "#61afef",
      "linkHover": "#74b9f1",
      "inlineCode": "#abce92",
      "inlineCodeBackground": "#393e46",
      "blockquote": "#c1c5cd",
      "blockquoteBorder": "#5c616b",
      "listMarker": "#61afefbf",
      "bold": "#abb2bf",
      "italic": "#abb2bfe6",
      "strikethrough": "#c1c5cd",
      "hr": "#5c616b"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#be4555",
        "foreground": "#ffffff",
        "contrast": 5.03
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#dbb1a8",
        "foreground": "#000000",
        "contrast": 10.87
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c2864a",
        "foreground": "#000000",
        "contrast": 6.8
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#e0e09b",
        "foreground": "#000000",
        "contrast": 15.31
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#95bc58",
        "foreground": "#000000",
        "contrast": 9.61
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#53c550",
        "foreground": "#000000",
        "contrast": 9.47
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#abdebc",
        "foreground": "#000000",
        "contrast": 13.91
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#55c58a",
        "foreground": "#000000",
        "contrast": 9.74
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#59b7ba",
        "foreground": "#000000",
        "contrast": 8.91
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#6e9bc3",
        "foreground": "#000000",
        "contrast": 7.14
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4868b2",
        "foreground": "#ffffff",
        "contrast": 5.39
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3841b8",
        "foreground": "#ffffff",
        "contrast": 8.03
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#9764c8",
        "foreground": "#000000",
        "contrast": 4.97
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d1a2de",
        "foreground": "#000000",
        "contrast": 9.93
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#bf48a3",
        "foreground": "#000000",
        "contrast": 4.67
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c36d93",
        "foreground": "#000000",
        "contrast": 5.93
      }
    ]
  }
}
